const handler = () => {
    // --- Modal ---

    const modal = document.createElement('div');
    modal.className = 'video-lightbox';
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('role', 'dialog');
    modal.innerHTML = `
        <div class="video-lightbox__overlay"></div>
        <div class="video-lightbox__container">
            <a href="#" class="video-lightbox__close" aria-label="Close video">
                <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M37.9995 42.4329L22.4829 57.9495C21.9023 58.5301 21.1634 58.8204 20.2662 58.8204C19.369 58.8204 18.6301 58.5301 18.0495 57.9495C17.469 57.369 17.1787 56.6301 17.1787 55.7329C17.1787 54.8357 17.469 54.0968 18.0495 53.5162L33.5662 37.9995L18.0495 22.4829C17.469 21.9023 17.1787 21.1634 17.1787 20.2662C17.1787 19.369 17.469 18.6301 18.0495 18.0495C18.6301 17.469 19.369 17.1787 20.2662 17.1787C21.1634 17.1787 21.9023 17.469 22.4829 18.0495L37.9995 33.5662L53.5162 18.0495C54.0968 17.469 54.8357 17.1787 55.7329 17.1787C56.6301 17.1787 57.369 17.469 57.9495 18.0495C58.5301 18.6301 58.8204 19.369 58.8204 20.2662C58.8204 21.1634 58.5301 21.9023 57.9495 22.4829L42.4329 37.9995L57.9495 53.5162C58.5301 54.0968 58.8204 54.8357 58.8204 55.7329C58.8204 56.6301 58.5301 57.369 57.9495 57.9495C57.369 58.5301 56.6301 58.8204 55.7329 58.8204C54.8357 58.8204 54.0968 58.5301 53.5162 57.9495L37.9995 42.4329Z" fill="currentColor"/>
                </svg>
            </a>
            <div class="video-lightbox__video">
                <iframe class="video-lightbox__iframe" allowfullscreen allow="autoplay; encrypted-media" frameborder="0"></iframe>
            </div>
        </div>
    `;
    document.body.appendChild(modal);

    const iframe = modal.querySelector('.video-lightbox__iframe');

    const open = (embedUrl) => {
        iframe.src = embedUrl;
        modal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
    };

    const close = () => {
        if (!modal.classList.contains('is-active')) return;
        modal.classList.remove('is-active');
        iframe.src = '';
        document.body.style.overflow = '';
    };

    modal.querySelector('.video-lightbox__overlay').addEventListener('click', close);
    modal.querySelector('.video-lightbox__close').addEventListener('click', (e) => { e.preventDefault(); close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    // --- Helpers ---

    const getVideoInfo = (url) => {
        const yt = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        if (yt) {
            const id = yt[1];
            return {
                type: 'youtube',
                id,
                embedUrl: `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`,
                thumbUrl: `https://img.youtube.com/vi/${id}/maxresdefault.jpg`,
            };
        }

        const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        if (vimeo) {
            const id = vimeo[1];
            return {
                type: 'vimeo',
                id,
                embedUrl: `https://player.vimeo.com/video/${id}?autoplay=1`,
                thumbUrl: null,
            };
        }

        return null;
    };

    const makeThumbnail = (videoInfo, altText) => {
        const wrap = document.createElement('div');
        wrap.className = 'video-thumb';

        const img = document.createElement('img');
        img.className = 'video-thumb__img';
        img.alt = altText || 'Video';

        const btn = document.createElement('a');
        btn.className = 'video-thumb__play';
        btn.setAttribute('aria-label', 'Play video');
        btn.href = '#';
        btn.innerHTML = `
            <svg width="124" height="124" viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M61.6667 0C49.4702 0 37.5476 3.61669 27.4065 10.3927C17.2655 17.1687 9.36153 26.7997 4.69412 38.0679C0.0267192 49.336 -1.19449 61.7351 1.18494 73.6972C3.56436 85.6594 9.43754 96.6474 18.0618 105.272C26.686 113.896 37.674 119.769 49.6361 122.148C61.5983 124.528 73.9974 123.307 85.2655 118.639C96.5336 113.972 106.165 106.068 112.941 95.9268C119.717 85.7858 123.333 73.8632 123.333 61.6667C123.333 53.5685 121.738 45.5496 118.639 38.0679C115.54 30.5861 110.998 23.788 105.272 18.0617C99.5453 12.3355 92.7473 7.79314 85.2655 4.6941C77.7838 1.59506 69.7649 0 61.6667 0ZM49.3334 89.4167V33.9167L86.3334 61.6667L49.3334 89.4167Z" fill="#141D47" fill-opacity="0.8"/>
            </svg>
        `;

        wrap.appendChild(img);
        wrap.appendChild(btn);
        wrap.addEventListener('click', (e) => { e.preventDefault(); open(videoInfo.embedUrl); });

        if (videoInfo.type === 'youtube') {
            img.src = videoInfo.thumbUrl;
            img.addEventListener('error', () => {
                img.src = `https://img.youtube.com/vi/${videoInfo.id}/hqdefault.jpg`;
            }, { once: true });
        } else if (videoInfo.type === 'vimeo') {
            fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoInfo.id}`)
                .then(r => r.json())
                .then(data => {
                    if (data.thumbnail_url) {
                        img.src = data.thumbnail_url.replace(/_\d+x\d+/, '_1280');
                    }
                })
                .catch(() => {});
        }

        return wrap;
    };

    // --- Scan content for video links ---

    const containers = document.querySelectorAll(
        '.resource-content-text, .entry-content, .wp-block-group__inner-container'
    );

    // --- Scan for Classic Editor oEmbed iframes (YouTube/Vimeo) ---
    containers.forEach(container => {
        container.querySelectorAll('iframe').forEach(iframe => {
            const src = iframe.getAttribute('src') || '';
            const videoInfo = getVideoInfo(src);
            if (!videoInfo) return;

            const thumb = makeThumbnail(videoInfo, '');
            const parent = iframe.parentElement;
            if (parent && parent.tagName === 'P') {
                parent.replaceWith(thumb);
            } else {
                iframe.replaceWith(thumb);
            }
        });
    });

    // --- Scan content for video links ---
    containers.forEach(container => {
        container.querySelectorAll('a[href]').forEach(link => {
            const videoInfo = getVideoInfo(link.getAttribute('href'));
            if (!videoInfo) return;

            // Only convert standalone links (paragraph contains only this link)
            const parent = link.parentElement;
            if (!parent) return;
            const isStandalone = ['P', 'LI'].includes(parent.tagName)
                && parent.textContent.trim() === link.textContent.trim();

            if (!isStandalone) return;

            const thumb = makeThumbnail(videoInfo, link.textContent.trim());
            parent.replaceWith(thumb);
        });
    });
};

export default (() => document.addEventListener('DOMContentLoaded', handler))();
